export class Address {
    id: string;
    description: string;
    aditionalInfo: string;
    country: string;
    state: string;
    city: string;
    zipCode: string;
    status: string;
    dateCrated: Date;
    dateUdated: Date
}
